// 默认交互状态
export const defaultStateStyles = {
  hover: {
    stroke: '#1890ff',
    lineWidth: 2,
  },
};

// card 默认节点大小
export const defaultNodeSize = [120, 40];

// 默认节点样式
export const defaultNodeStyle = {
  stroke: '#40a9ff',
};

// 默认 anchor 连接点
export const defaultFlowGraphAnchorPoints = [
  [0, 0.5],
  [1, 0.5],
];

// card body|footer  默认样式
export const defaultLabelStyle = {
  fill: '#000',
  fontSize: 12,
};
export const defaultLineLabelStyle = {
  fill: '#000',
  fontSize: 12,
  textAlign: 'start',
  textBaseline: 'middle',
};
// 缩略图默认配置
export const defaultMinimapCfg = {
  show: false,
  size: [150, 100],
  type: 'keyShape',
};

// card 默认样式
export const defaultCardStyle = {
  fill: '#fff',
  stroke: '#40a9ff',
  radius: 2,
};

// card 内部 padding | margin | 行间距
export const defaultMargin = 6;

// 打标前缀
export const prefix = 'g';
